module.exports = __webpack_public_path__ + "img/20200515_160410.6dbb12f8.jpg";